// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"7cdef581","832":"a9fc99b5","928":"adea5946"}[chunkId] + ".chunk.js";
};